export default "__VITE_ASSET__01614bfd__"